import { useContext, useEffect, useState } from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { Link, useLocation } from 'libs/router'

import { IDropdownItemComponent, IDropdownItem } from './types'
import { NavContext } from 'store/NavContext'
import { cn } from 'utils/style'
import { navItemClassName } from './NavItem'

export const isDropdownItemActive = ({ to, activePaths = [] }: IDropdownItem, pathname: string) =>
	[to, ...activePaths].some((path) => pathname === path || pathname.startsWith(`${path}/`))

export const DropdownItem = ({
	items,
	labelText,
	icon,
	isActive = false
}: IDropdownItemComponent) => {
	const { pathname } = useLocation()
	const [isOpen, setOpen] = useState(isActive)
	const navCtx = useContext(NavContext)
	const closeSidebar = () => {
		navCtx?.toggleNavOpened(false)
	}

	useEffect(() => {
		if (isActive) setOpen(true)
	}, [isActive])

	return (
		<div>
			<button
				type="button"
				aria-expanded={isOpen}
				className={cn(
					navItemClassName,
					isActive
						? 'bg-primary-soft text-primary'
						: 'text-muted-foreground hover:bg-muted hover:text-foreground'
				)}
				onClick={() => setOpen(!isOpen)}>
				{icon}
				<span className="truncate">{labelText}</span>
				<span className="ml-auto">
					<ChevronDownIcon
						className={cn(
							'h-3.5 w-3.5 stroke-2 transition-transform duration-200',
							isOpen && 'rotate-180'
						)}
					/>
				</span>
			</button>
			{isOpen && (
				<div className="ml-[22px] mt-1 space-y-0.5 border-l border-border py-1 pl-3">
					{items.map((item: IDropdownItem, index: number) => {
						const isItemActive = isDropdownItemActive(item, pathname)

						return (
							<Link
								key={index}
								to={item.to}
								aria-current={isItemActive ? 'page' : undefined}
								className={cn(
									'block w-full rounded-md px-2 py-1.5 text-[12px] font-medium transition-colors',
									isItemActive
										? 'bg-muted text-foreground'
										: 'text-muted-foreground hover:bg-muted hover:text-foreground'
								)}
								onClick={closeSidebar}>
								{item.label}
							</Link>
						)
					})}
				</div>
			)}
		</div>
	)
}
